import { Send, UserCheck } from 'lucide-react';

/**
 * Small badge showing HOW an agent was approved:
 *   - "invited": got here via a valid ASB606 invite code (auto-approved).
 *   - "direct":  applied directly, later approved by admin.
 *
 * Renders nothing if `agentType` is empty (safe for non-agents).
 */
export default function AgentTypeBadge({ agentType, language = 'ar', size = 'sm' }) {
  if (!agentType) return null;

  const isInvited = agentType === 'invited';
  const sizeCls = size === 'sm'
    ? 'text-[10px] px-2 py-0.5'
    : 'text-xs px-2.5 py-1';

  const label = isInvited
    ? (language === 'ar' ? 'مدعو' : 'Invited')
    : (language === 'ar' ? 'تقديم مباشر' : 'Direct');

  const Icon = isInvited ? Send : UserCheck;

  const colorCls = isInvited
    ? 'bg-blue-500/10 text-blue-500 border-blue-500/30'
    : 'bg-green-500/10 text-green-600 border-green-500/30';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${sizeCls} ${colorCls}`}
      data-testid={`agent-type-badge-${agentType}`}
      title={label}
    >
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
}
